export function getCookie(name) {
  const target = `${String(name || '').trim()}=`
  const decoded = decodeURIComponent(document.cookie || '')
  const parts = decoded.split(';')
  for (const part of parts) {
    const value = part.trim()
    if (value.startsWith(target)) {
      return value.slice(target.length)
    }
  }
  return ''
}
